module.exports = __webpack_public_path__ + "img/visual-07.366d0763.png";